import createTypes from 'redux-create-action-types';

export default createTypes('SEARCH_DOT_NUMBER');
